
import { defineComponent } from "vue";

export default defineComponent({
  name: "Tile",
  props: {
    title: String,
  }
});
